import classnames from "classnames";
import "./CDTypography.scss";
import { CDTypographyVariant } from "./CDTypographyVariant";
import { CDTypographyColor } from "./CDTypographyColor";
import { forwardRef } from "react";

interface ICDataTypographyProps {
  variant?: CDTypographyVariant;
  color?: CDTypographyColor;
  className?: string;
  children: React.ReactNode;
}

export const CDTypography = forwardRef(function CDTypography(
  props: ICDataTypographyProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const { variant, color, className, children, ...otherProps } = props;

  return (
    <div
      className={classnames(
        "cdata-typography",
        variant,
        color,
        { "typography-variant-body-regular": !variant },
        { "typography-color-text-regular": !color },
        className,
      )}
      ref={ref}
      // Spread the props here is required for forwardRef to work correctly
      {...otherProps}
    >
      {children}
    </div>
  );
});
